<template>
  <div v-if="!submitted" class="text-center mb-8">
    <div v-if="step > 0 && step <= total" class="text-xs font-medium text-primary/70 uppercase tracking-wider mb-3">
      {{ t("smartLeadForm.progress", { step, total }) }}
    </div>
    <h2 v-if="heading" class="text-2xl font-bold text-base-content leading-tight">
      {{ $t(heading) }}
    </h2>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
const props = defineProps<{
  step: number;
  total: number;
  submitted: boolean;
}>();
const { t } = useI18n();
const headings = {
  1: "smartLeadForm.situation.title",
  2: "smartLeadForm.primaryGoal.title", 
  3: "smartLeadForm.investment.title",
  4: "smartLeadForm.involvement.title",
  5: "smartLeadForm.timeline.title",
  6: "smartLeadForm.planReady.title",
  7: "smartLeadForm.contact.title",
  8: "smartLeadForm.gdpr.title",
};

const heading = computed(() => headings[props.step] || "");
</script>
